<template>
  <v-footer absolute>
    <v-spacer></v-spacer>
    <div class="footer">Powered by YODLEE </div>
  </v-footer>
</template>

<script>
export default {
 
};
</script>

<style lang="scss">
footer.v-footer {
  height: 40px;
  background: #FAFAFA;
  .footer {
    font-size: 14px;
    line-height: 17px;
    color: #77716F;
  }
}

</style>
